module.exports = __webpack_public_path__ + "img/dzp.00009d8b.jpg";